import { compose } from 'recompose'
import { connect } from 'react-redux'
import {
  selectCustomerIBuyerName,
  selectCustomerIBuyerUri,
  selectCustomerFirstName,
  selectIbuyerVideoType,
  selectIbuyerVideoEnabled,
  selectIbuyerVideoExternalId
} from 'src/store/selectors/customerProfile'
import { sendInstantOfferRequest } from 'src/actions/instantOffer'

const InstantOfferContainer = compose(
  connect(
    state => ({
      customerFirstName: selectCustomerFirstName(state),
      productName: selectCustomerIBuyerName(state),
      href: selectCustomerIBuyerUri(state),
      ibuyerVideoType: selectIbuyerVideoType(state),
      ibuyerVideoEnabled: selectIbuyerVideoEnabled(state),
      ibuyerVideoExternalId: selectIbuyerVideoExternalId(state)
    }),
    dispatch => ({
      onClick: () => dispatch(sendInstantOfferRequest())
    })
  )
)

export default InstantOfferContainer
